interface Props {
  lastSyncAt: number | null;
}

const CRON_INTERVAL_MINUTES = 5;

function formatUtc(unixTs: number): string {
  const d = new Date(unixTs * 1000);
  return d.toISOString().replace('T', ' ').replace(/\.\d{3}Z$/, ' UTC');
}

function computeNextSync(lastSyncAt: number): { secondsFromNow: number; at: number } {
  const nowSec = Math.floor(Date.now() / 1000);
  const intervalSec = CRON_INTERVAL_MINUTES * 60;
  const elapsed = nowSec - lastSyncAt;
  const remaining = intervalSec - (elapsed % intervalSec);
  return { secondsFromNow: remaining, at: nowSec + remaining };
}

export function EmptyState({ lastSyncAt }: Props) {
  if (lastSyncAt == null) {
    return (
      <section className="empty-state" aria-label="empty-state">
        <h2>🕐 系統啟動中</h2>
        <p>尚未執行任何同步。Cron 每 {CRON_INTERVAL_MINUTES} 分鐘觸發一次,請稍候。</p>
        <p className="hint">
          <em>(This dashboard has not yet run its first sync.)</em>
        </p>
      </section>
    );
  }

  const next = computeNextSync(lastSyncAt);
  const mm = Math.floor(next.secondsFromNow / 60);
  const ss = next.secondsFromNow % 60;

  return (
    <section className="empty-state" aria-label="empty-state">
      <h2>🕐 等待第一筆資料</h2>
      <p>系統正在收集第一筆 metrics,請稍候。</p>
      <dl>
        <dt>上次同步:</dt>
        <dd>{formatUtc(lastSyncAt)}</dd>
        <dt>下次同步:</dt>
        <dd>
          約 {mm} 分 {String(ss).padStart(2, '0')} 秒後({formatUtc(next.at)})
        </dd>
      </dl>
    </section>
  );
}
